import { useTheme } from '@/context/useTheme';

export const IconLinkedin = ({ className }: { className?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 50 50"
            width="50px"
            height="50px"
            fill="none"
            className={className}
        >
            <path
                fill="currentColor"
                d="M 8 3.0097656 C 4.53 3.0097656 2.0097656 5.0892187 2.0097656 7.9492188 C 2.0097656 10.819219 4.59 12.990234 8 12.990234 C 11.47 12.990234 13.990234 10.870625 13.990234 7.890625 C 13.830234 5.020625 11.36 3.0097656 8 3.0097656 z M 3 15 C 2.45 15 2 15.45 2 16 L 2 45 C 2 45.55 2.45 46 3 46 L 13 46 C 13.55 46 14 45.55 14 45 L 14 16 C 14 15.45 13.55 15 13 15 L 3 15 z M 18 15 C 17.45 15 17 15.45 17 16 L 17 45 C 17 45.55 17.45 46 18 46 L 27 46 C 27.552 46 28 45.552 28 45 L 28 30 L 28 29.75 L 28 29.5 C 28 27.13 29.820625 25.199531 32.140625 25.019531 C 32.260625 24.999531 32.38 25 32.5 25 C 32.62 25 32.739375 24.999531 32.859375 25.019531 C 35.179375 25.199531 37 27.13 37 29.5 L 37 45 C 37 45.552 37.448 46 38 46 L 47 46 C 47.55 46 48 45.55 48 45 L 48 28 C 48 21.53 44.529063 15 36.789062 15 C 33.269062 15 30.61 16.360234 29 17.490234 L 29 16 C 29 15.45 28.55 15 28 15 L 18 15 z"
            />
        </svg>
    );
};
export const IconFacebook = ({ className }: { className?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 50 50"
            width="50px"
            height="50px"
            fill="none"
            className={className}
        >
            <path
                fill="currentColor"
                d="M32,11h5c0.552,0,1-0.448,1-1V3.263c0-0.524-0.403-0.96-0.925-0.997C35.484,2.153,32.376,2,30.141,2C24,2,20,5.68,20,12.368 V19h-7c-0.552,0-1,0.448-1,1v7c0,0.552,0.448,1,1,1h7v19c0,0.552,0.448,1,1,1h7c0.552,0,1-0.448,1-1V28h7.222 c0.51,0,0.938-0.383,0.994-0.89l0.778-7C38.06,19.518,37.596,19,37,19h-8v-5C29,12.343,30.343,11,32,11z"
            />
        </svg>
    );
};

export const IconInstagram = ({ className }: { className?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 30 30"
            width="50px"
            height="50px"
            fill="none"
            className={className}
        >
            <path
                fill="currentColor"
                d="M 9.9980469 3 C 6.1390469 3 3 6.1419531 3 10.001953 L 3 20.001953 C 3 23.860953 6.1419531 27 10.001953 27 L 20.001953 27 C 23.860953 27 27 23.858047 27 19.998047 L 27 9.9980469 C 27 6.1390469 23.858047 3 19.998047 3 L 9.9980469 3 z M 22 7 C 22.552 7 23 7.448 23 8 C 23 8.552 22.552 9 22 9 C 21.448 9 21 8.552 21 8 C 21 7.448 21.448 7 22 7 z M 15 9 C 18.309 9 21 11.691 21 15 C 21 18.309 18.309 21 15 21 C 11.691 21 9 18.309 9 15 C 9 11.691 11.691 9 15 9 z M 15 11 A 4 4 0 0 0 11 15 A 4 4 0 0 0 15 19 A 4 4 0 0 0 19 15 A 4 4 0 0 0 15 11 z"
            />
        </svg>
    );
};

export const IconSnapchat = ({ className }: { className?: string }) => {
    return (
        <svg
            width="800px"
            height="800px"
            viewBox="0 0 48 48"
            id="b"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g id="c">
                <path
                    id="d"
                    fill="currentColor"
                    stroke="#000000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m24.0116,42.2697c3.8272-.0024,4.9669-1.6066,7.486-2.7237,2.2497-.9976,5.4694.5087,6.1373-2.1616h0c.0865-1.3801,2.513-1.1579,3.8742-2.0996,1.2418-.8591,1.3659-2.2361.0902-2.778-2.8877-1.2269-5.9232-3.9144-6.6578-6.7964-.4582-1.7978,5.2788-2.3506,4.0841-5.7402-.7049-2.0001-3.2379-1.2958-4.616-.8478.9182-7.1086-2.542-13.3923-10.4098-13.3923s-11.328,6.2837-10.4098,13.3923c-1.378-.448-3.911-1.1523-4.616.8478-1.1947,3.3896,4.5424,3.9424,4.0841,5.7402-.7346,2.882-3.77,5.5695-6.6578,6.7964-1.2757.542-1.1516,1.9189.0902,2.778,1.3612.9417,3.7878.7195,3.8742,2.0996h0c.6679,2.6703,3.8876,1.164,6.1373,2.1616,2.5191,1.1171,3.6588,2.7213,7.486,2.7237.0058,0,.0173,0,.0231,0Z"
                />
            </g>
        </svg>
    );
};

export const IconTiktok = ({ className }: { className?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40px"
            height="40px"
            viewBox="0 0 16 16"
            fill="none"
            id="tiktok"
            className={className}
        >
            <path
                fill="#ffffff"
                d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z"
            />
        </svg>
    );
};

export const IconTwitterX = ({ className }: { className?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            className={className}
            viewBox="0 0 50 50"
            width="50px"
            height="50px"
        >
            <path
                fill="currentColor"
                d="M 5.9199219 6 L 20.582031 27.375 L 6.2304688 44 L 9.4101562 44 L 21.986328 29.421875 L 31.986328 44 L 44 44 L 28.681641 21.669922 L 42.199219 6 L 39.029297 6 L 27.275391 19.617188 L 17.933594 6 L 5.9199219 6 z M 9.7167969 8 L 16.880859 8 L 40.203125 42 L 33.039062 42 L 9.7167969 8 z"
            />
        </svg>
    );
};
export const IconYoutube = ({ className }: { className?: string }) => {
    const { theme } = useTheme();
    const strokeColor = theme === 'dark' ? '#000000' : '#ffffff';

    return (
        <svg
            width="50px"
            height="50px"
            viewBox="0 0 64 64"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            className={className}
            stroke={strokeColor}
        >
            <path
                fill="currentColor"
                d="M55.16 20.42A5.94 5.94 0 0 0 50 15.6c-6-.38-12-.69-18-.7s-12 .3-18 .68a5.94 5.94 0 0 0-5.17 4.82 79.25 79.25 0 0 0 0 22.88 6.17 6.17 0 0 0 5.19 5c6 .38 12 .77 18 .77s12-.34 18-.73a6.24 6.24 0 0 0 5.18-5.1 78.19 78.19 0 0 0 .8-11.38 78 78 0 0 0-.84-11.42z"
            />
            <polygon fill={strokeColor} points="26.56 38.73 26.56 24.79 39.55 31.76 26.56 38.73" />
        </svg>
    );
};
export const WhatsappIcon = ({ className }: { className?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="70px"
            height="70px"
            viewBox="0 0 48 48"
            fill="none"
            id="whatsapp"
            className={className}
        >
            <path
                fill="#ffffff"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.791 37.353h-.006c-2.388-.001-4.735-.6-6.82-1.738L10.4 37.6l2.025-7.395a14.246 14.246 0 0 1-1.905-7.135c.003-7.868 6.405-14.27 14.27-14.27 3.819.002 7.402 1.488 10.096 4.185a14.185 14.185 0 0 1 4.176 10.097c-.003 7.866-6.402 14.267-14.27 14.27Zm-6.475-4.321.433.257a11.844 11.844 0 0 0 6.037 1.653h.005c6.538 0 11.859-5.32 11.862-11.861a11.79 11.79 0 0 0-3.471-8.392 11.78 11.78 0 0 0-8.386-3.479c-6.543 0-11.864 5.321-11.867 11.861 0 2.241.626 4.424 1.814 6.313l.282.448-1.199 4.378 4.49-1.178Zm13.176-6.878c.25.12.417.201.489.321.089.149.089.863-.208 1.696s-1.722 1.593-2.407 1.695c-.614.092-1.392.13-2.246-.14a20.465 20.465 0 0 1-2.033-.752c-3.343-1.444-5.602-4.684-6.029-5.296-.03-.043-.05-.073-.063-.088l-.002-.004c-.189-.252-1.453-1.94-1.453-3.685 0-1.643.806-2.504 1.178-2.9l.07-.075a1.31 1.31 0 0 1 .95-.446c.238 0 .476.002.684.012.026.002.052.002.08.001.207 0 .467-.002.722.612.099.236.242.586.394.956.307.747.646 1.572.706 1.691.089.179.148.387.03.625l-.05.102c-.09.182-.156.316-.307.493-.06.07-.121.144-.183.22-.123.149-.245.298-.352.405-.179.177-.364.37-.157.727.209.357.924 1.525 1.984 2.47 1.14 1.017 2.13 1.447 2.632 1.664.098.043.178.077.236.106.356.179.564.15.772-.089.208-.238.892-1.041 1.13-1.398.237-.357.475-.297.802-.179.327.12 2.08.982 2.436 1.16l.195.096Z"
            />
        </svg>
    );
};

export const SnapchatIcon = ({ className }: { className?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="70px"
            height="70px"
            viewBox="0 0 24 24"
            fill="none"
            id="snapchat"
            className={className}
        >
            <path
                fill="#ffffff"
                d="M12.374 2.754c-2.966 0-4.638 1.968-5.533 3.99-.967 2.187-1.04 4.638-.287 6.89l.018.056c.07.215.033.43-.101.588-.19.223-.52.315-.948.276-1.06-.097-1.497-.783-1.68-1.162-.23-.48-.577-.723-1.09-.723-.684 0-1.372.398-1.372 1.27 0 .508.256.93.71 1.178.042.023.085.045.128.067.008.256.03.777.288 1.11.29.373.844.51 1.316.51.335 0 .69-.065 1.055-.204.42-.16.745-.284 1.01-.284.398 0 .723.246.845.644.11.358.065.763-.128 1.13-.284.54-.895 1.018-2.073 1.276-.097.021-.204.042-.317.065-.68.14-1.36.28-1.743.713-.383.433-.383 1.073.003 1.638.724 1.06 2.083 1.507 3.38 1.507.265 0 .538-.013.817-.046 1.158-.137 1.913-.895 2.026-1.034.163-.2.365-.288.575-.245.21.043.377.19.463.378.448.98 1.27 1.39 2.136 1.39.866 0 1.688-.41 2.136-1.39.086-.188.253-.335.463-.378.21-.043.412.045.575.245.113.139.868.897 2.026 1.034.28.033.552.046.817.046 1.297 0 2.656-.447 3.38-1.507.386-.565.386-1.205.003-1.638-.383-.433-1.063-.573-1.743-.713-.113-.023-.22-.044-.317-.065-1.178-.258-1.789-.736-2.073-1.276-.193-.367-.238-.772-.128-1.13.122-.398.447-.644.845-.644.265 0 .59.124 1.01.284.365.139.72.204 1.055.204.472 0 1.026-.137 1.316-.51.258-.333.28-.854.288-1.11.043-.022.086-.044.128-.067.454-.248.71-.67.71-1.178 0-.872-.688-1.27-1.372-1.27-.513 0-.86.243-1.09.723-.183.379-.62 1.065-1.68 1.162-.428.039-.758-.053-.948-.276-.134-.158-.171-.373-.101-.588l.018-.056c.753-2.252.68-4.703-.287-6.89-.895-2.022-2.567-3.99-5.533-3.99Z"
            />
        </svg>
    );
};
export const TelegramIcon = ({ className }: { className?: string }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40px"
            height="40px"
            viewBox="0 0 16 16"
            fill="none"
            id="telegram"
            className={className}
        >
            <path
                fill="#ffffff"
                d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09"
            />
        </svg>
    );
};
